export function RemoveStringAccented (stringAccented: any) {
  if (typeof stringAccented === 'string') {
    stringAccented = stringAccented.normalize("NFD");
    stringAccented = stringAccented.replace(/[\u0300-\u036f]/g, "");
    stringAccented = stringAccented.replace(/[đĐ]/g, m => m === 'đ' ? 'd' : 'D');
    stringAccented = stringAccented.toUpperCase();
    return stringAccented;
  }
}
